'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultPortalId;

var _PortalIdParser = require('PortalIdParser');

var _PortalIdParser2 = _interopRequireDefault(_PortalIdParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultPortalId() {
  return _PortalIdParser2.default.get();
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2292/js/lib/defaultPortalId.js
// module id = 497
// module chunks = 177